import React, { useState, useEffect, useContext } from "react";
import "./staffInfoModal.css";
import { CombinedContext } from "../../../context/combinedContext";
import companyBasedRequest from "../../../request/companyBasedRequest";
import translations from "../../../translations/translations";

const StaffInfoModal = ({ open, onClose, staffProfile, onSave }) => {
	const { userData, language } = useContext(CombinedContext);

	const [local, setLocal] = useState({
		firstName: "",
		lastName: "",
		bio: "",
		phone: "",
	});

	const [saving, setSaving] = useState(false);

	useEffect(() => {
		if (staffProfile) {
			setLocal({
				firstName: staffProfile.firstName || "",
				lastName: staffProfile.lastName || "",
				bio: staffProfile.bio || "",
			});
		}
	}, [staffProfile]);

	if (!open) return null;

	const handleSave = async () => {
		const updateData = {
			firstName: local.firstName,
			lastName: local.lastName,
			bio: local.bio,
		};

		try {
			setSaving(true);

			await companyBasedRequest.updateStaffInfo(
				staffProfile.staffId,
				updateData,
				userData.cognitoTokens.AccessToken
			);

			onSave?.(updateData);

			onClose(); // close only after success
		} catch (err) {
			console.error("❌ Failed updating staff info", err);
		} finally {
			setSaving(false);
		}
	};

	return (
		<div className="sf-staffinfo-overlay" onClick={onClose}>
			<div className="sf-staffinfo-modal" onClick={(e) => e.stopPropagation()}>
				{/* HEADER */}
				<div className="sf-staffinfo-header">
					<h2 className="sf-staffinfo-title">
						{translations[language]?.teamPage?.editProfile || "Edit Profile"}
					</h2>
					<button className="sf-staffinfo-close" onClick={onClose}>
						✕
					</button>
				</div>

				{/* BODY */}
				<div className="sf-staffinfo-body">
					<div className="sf-staffinfo-group">
						<h3>
							{translations[language]?.teamPage?.labels?.firstName || "First Name"}
						</h3>
						<input
							className="sf-staffinfo-input"
							value={local.firstName}
							onChange={(e) =>
								setLocal({ ...local, firstName: e.target.value })
							}
						/>
					</div>

					<div className="sf-staffinfo-group">
						<h3>
							{translations[language]?.teamPage?.labels?.lastName || "Last Name"}
						</h3>
						<input
							className="sf-staffinfo-input"
							value={local.lastName}
							onChange={(e) =>
								setLocal({ ...local, lastName: e.target.value })
							}
						/>
					</div>
					
					<div className="sf-staffinfo-group">
						<h3>{translations[language].profileStaff.staffInfo.phone}</h3>
						<input
							className="sf-staffinfo-input"
							type="tel"
							value={local.phone}
							onChange={(e) => setLocal({ ...local, phone: e.target.value })}
						/>
					</div>

					<div className="sf-staffinfo-group">
						<h3>{translations[language]?.teamPage?.labels?.bio || "Bio"}</h3>
						<textarea
							className="sf-staffinfo-input sf-staffinfo-textarea"
							value={local.bio}
							onChange={(e) =>
								setLocal({ ...local, bio: e.target.value })
							}
						/>
					</div>
				</div>

				{/* FOOTER (STANDARDIZED) */}
				<div className="sf-base-footer">
					<button
						className="btn ghost"
						onClick={onClose}
						disabled={saving}
					>
						{translations[language]?.calendar?.editor?.cancel || "Cancel"}
					</button>

					<button
						className="btn"
						onClick={handleSave}
						disabled={saving}
					>
						{saving
							? translations[language]?.calendar?.editor?.saving || "Saving..."
							: translations[language]?.calendar?.editor?.save || "Save"}
					</button>
				</div>
			</div>
		</div>
	);
};

export default StaffInfoModal;